import { Helmet } from 'react-helmet-async';
import { schemas } from '../config/structuredData';

const StructuredData = ({ type }) => {
  const schema = schemas[type];
  
  if (!schema) return null;
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;

